document.addEventListener('DOMContentLoaded',()=>{const b=document.querySelector('.menu-button'),n=document.querySelector('.mobile-nav');if(b&&n)b.addEventListener('click',()=>{const open=b.getAttribute('aria-expanded')==='true';b.setAttribute('aria-expanded',String(!open));n.classList.toggle('open',!open)});document.querySelectorAll('.mobile-nav a').forEach(a=>a.addEventListener('click',()=>{n?.classList.remove('open');b?.setAttribute('aria-expanded','false')}))});

document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('.product-form.configurator');
  const stage = document.querySelector('[data-stage]');
  if (!form) return;

  const frames = stage ? [...stage.querySelectorAll('[data-frame]')] : [];
  const thumbs = stage ? stage.querySelector('[data-stage-thumbs]') : null;
  const viewport = stage ? stage.querySelector('[data-stage-viewport]') : null;
  const variantInput = form.querySelector('[data-variant-input]');
  const priceEl = document.querySelector('[data-config-price]');
  const summaryEl = document.querySelector('[data-config-summary-text]');

  const state = {
    color: form.querySelector('[data-color-button].is-selected')?.dataset.color || '',
    size: 'Medium',
    frame: form.querySelector('[data-frame-button].is-selected')?.dataset.value || '',
    view: 0
  };

  const norm = (s) => (s || '').toLowerCase().replace(/[^a-z]/g, '');
  const framesForColor = () => {
    if (!frames.length) return [];
    const key = norm(state.color);
    const matched = key ? frames.filter(f => (norm(f.dataset.imageAlt).includes(key) || norm(f.dataset.imageColors).includes(key))) : [];
    return matched.length ? matched : frames;
  };

  function renderStage() {
    const set = framesForColor();
    if (!set.length) return;
    if (state.view >= set.length) state.view = 0;
    if (state.view < 0) state.view = set.length - 1;
    frames.forEach(f => f.classList.remove('is-active'));
    set[state.view].classList.add('is-active');
    if (thumbs) {
      thumbs.innerHTML = '';
      if (set.length > 1) {
        set.forEach((f, i) => {
          const t = document.createElement('button');
          t.type = 'button';
          t.className = 'stage-thumb' + (i === state.view ? ' is-active' : '');
          t.setAttribute('aria-label', 'View ' + (i + 1));
          const img = f.querySelector('img');
          if (img) {
            const thumbImg = document.createElement('img');
            thumbImg.src = img.currentSrc || img.src;
            thumbImg.alt = '';
            t.appendChild(thumbImg);
          }
          t.addEventListener('click', () => { state.view = i; renderStage(); });
          thumbs.appendChild(t);
        });
      }
    }
    if (stage) stage.classList.toggle('has-views', set.length > 1);
  }

  function renderSummary() {
    if (!summaryEl) return;
    summaryEl.textContent = [state.color, state.size + ' fit', state.frame].filter(Boolean).join(' · ');
  }

  form.querySelectorAll('[data-color-button]').forEach(btn => {
    btn.addEventListener('click', () => {
      form.querySelectorAll('[data-color-button]').forEach(b => {
        b.classList.remove('is-selected');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');
      state.color = btn.dataset.color || '';
      state.view = 0;
      if (variantInput) variantInput.value = btn.dataset.variantId;
      if (priceEl && btn.dataset.price) priceEl.textContent = btn.dataset.price;
      const label = document.querySelector('[data-config-color-label]');
      if (label) label.textContent = state.color;
      renderStage();
      renderSummary();
    });
  });

  form.querySelectorAll('[data-size-button]').forEach(btn => {
    btn.addEventListener('click', () => {
      form.querySelectorAll('[data-size-button]').forEach(b => {
        b.classList.remove('is-selected');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');
      state.size = btn.dataset.short || '';
      const input = form.querySelector('[data-size-input]');
      if (input) input.value = btn.dataset.value;
      const label = document.querySelector('[data-config-size-label]');
      if (label) label.textContent = state.size;
      renderSummary();
    });
  });

  form.querySelectorAll('[data-frame-button]').forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.disabled) return;
      form.querySelectorAll('[data-frame-button]').forEach(b => {
        b.classList.remove('is-selected');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');
      state.frame = btn.dataset.value || '';
      const input = form.querySelector('[data-frame-input]');
      if (input) input.value = state.frame;
      const label = document.querySelector('[data-config-frame-label]');
      if (label) label.textContent = state.frame;
      renderSummary();
    });
  });

  if (viewport) {
    let startX = null;
    const step = (dir) => {
      const set = framesForColor();
      if (set.length < 2) return;
      state.view = (state.view + dir + set.length) % set.length;
      renderStage();
    };
    viewport.addEventListener('pointerdown', (e) => { startX = e.clientX; });
    viewport.addEventListener('pointermove', (e) => {
      if (startX === null) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 55) { step(dx < 0 ? 1 : -1); startX = e.clientX; }
    });
    ['pointerup', 'pointerleave', 'pointercancel'].forEach(ev =>
      viewport.addEventListener(ev, () => { startX = null; })
    );
    viewport.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
    });
  }

  renderStage();
  renderSummary();
});
